import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import images from "../../assets/images";
import { useSelector } from "react-redux";
import { getLocalization } from "../../redux/localization";
import { clientAppUrl } from "../../redux/base/types/url";
import { useParams } from "react-router";

const SuccessPaymentPage: React.FC = () => {
  const { id } = useParams<any>();
  const [counter, setCounter] = useState(5);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const t = useSelector(getLocalization);
  useEffect(() => {
    if (counter > 0) {
      const countdown = setInterval(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);

      setTimeout(() => {
        clearInterval(countdown);
        setButtonDisabled(false);
      }, 5000);

      return () => clearInterval(countdown);
    }
  }, []);

  return (
    <React.Fragment>
      <Container>
        <div className=" defaultPage ">
          <div className="pricingPage">
            <div className="d-flex justify-content-center align-items-center flex-column">
              {/* <i
                className=" bx bx-check-circle text-success "
                style={{ fontSize: 88 }}
              /> */}
              <img src={images.party} width={120} />
              <div
                style={{ maxWidth: "50%" }}
                className="d-flex justify-content-center align-items-center flex-column"
                dangerouslySetInnerHTML={{
                  __html: t
                    .formatString(t.getString("successpagecontent"), counter)
                    .toString(),
                }}
              />

              <button
                disabled={buttonDisabled}
                onClick={() =>
                  window.open(clientAppUrl + "/login/" + id, "_blank")
                }
                className={
                  "bg-soft-success btn btn-success" +
                  (buttonDisabled ? " btn-disabled" : "")
                }
              >
                {buttonDisabled ? (
                  <>{t.formatString(t.getString("countertext"), counter)}</>
                ) : (
                  <>{t.getString("successpagebuttontitle")}</>
                )}
              </button>
            </div>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default SuccessPaymentPage;
